import { useSelector } from "react-redux";
import DataTableBase from "./DataTableBase";
import { useTranslation } from "react-i18next";
import React from "react";
import { useNavigate } from "react-router-dom";
import { store } from "../../store";
import { Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Store, Star, Business, Place } from "@mui/icons-material";

export default function EstablishmentsTable({ filteredEstablishments }) {
  const establishments = useSelector((state) => state.establishments);
  const brands = useSelector((state) => state.brands);
  const userDB = useSelector((state) => state.userDB);

  const navigate = useNavigate();

  const { t } = useTranslation("common");

  // Utiliser les établissements filtrés si fournis, sinon tous
  const displayData = filteredEstablishments || establishments;

  const columns = [
    {
      name: "id",
      label: "ID",
      options: {
        display: false,
        filter: false,
        sort: true,
      },
    },
    {
      name: "name",
      label: t("common.name"),
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          let establishment = displayData.find(
            (establishment) =>
              parseInt(establishment.id) === parseInt(tableMeta.rowData[0])
          );

          const displayName = establishment?.is_zone
            ? value + " " + establishment.zone_name
            : value;

          return (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Store sx={{ color: "#78a882", fontSize: 20 }} />
              <Typography sx={{ color: "#ffffff", fontWeight: 500 }}>
                {displayName}
              </Typography>
              {establishment?.is_zone && (
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, ml: 1 }}>
                  <Place sx={{ color: "#8a9ba8", fontSize: 18 }} />
                  <Typography sx={{ color: "#8a9ba8", fontWeight: 500, fontSize: "0.85rem" }}>
                    Zone
                  </Typography>
                </Box>
              )}
            </Box>
          );
        },
      },
    },
    {
      name: "stars",
      label: t("common.stars"),
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return (
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              {Array.from({ length: value || 0 }, (_, index) => (
                <Star key={index} sx={{ color: "#c4a574", fontSize: 20 }} />
              ))}
              {Array.from({ length: 5 - (value || 0) }, (_, index) => (
                <Star key={`empty-${index}`} sx={{ color: alpha("#c4a574", 0.2), fontSize: 20 }} />
              ))}
            </Box>
          );
        },
      },
    },
    {
      name: "brand_id",
      label: t("common.brand"),
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          let brand = brands.find(
            (brand) => parseInt(brand.id) === parseInt(value)
          );

          return brand ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Business sx={{ color: "#6b9dad", fontSize: 20 }} />
              <Typography sx={{ color: "#ffffff", fontWeight: 500 }}>
                {brand.name}
              </Typography>
            </Box>
          ) : (
            "-"
          );
        },
      },
    },
  ];

  const [selectedEstablishments, setSelectedestablishments] = React.useState(
    []
  );
  const [selectedRows, setSelectedRows] = React.useState([]);

  const tableActions = [
    {
      name: t("common.delete_selected", {
        name: t("common.establishments"),
        count: selectedEstablishments.length,
      }),
      icon: "Delete",
      action: () => {
        store.dispatch({
          type: "deleteDialog/update",
          payload: {
            open: true,
            type: "establishments",
            records: selectedEstablishments,
          },
        });
      },
    },
  ];

  return (
    <DataTableBase
      columns={columns}
      data={displayData}
      title={t("common.establishments")}
      id="establishment-list"
      name="establishment-list"
      pageSize={10}
      selectedItems={selectedEstablishments}
      setSelectedItems={setSelectedestablishments}
      selectedRows={selectedRows}
      setSelectedRows={setSelectedRows}
      selectableRows={userDB ? (userDB.admin ? "multiple" : "none") : "none"}
      actions={tableActions}
      sortOrder="dev_eui"
      onRowClick={(rowData, rowMeta) => {
        navigate(`/establishments/${displayData[rowMeta.dataIndex].id}`);
      }}
    />
  );
}
